module.exports = __webpack_public_path__ + "static/media/apps icon 2.98948bc6.png";